<template>
  <artmisads-modal
    v-model:open="props.open"
    title="View Report"
    width="1200px"
    :footer="null"
    @cancel="emit('update:open', false)"
  >
    <div class="view-report">
      <div class="search-bar">
        <a-input-search
          v-model:value="searchValue"
          placeholder="search name"
          @search="onSearch"
        />
      </div>
      <div class="table-wrapper">
      <artmisads-table
        :loading="loading"
        :columns="columns"
        :scroll="{x: 2100,y: tableScrollHeight}"
        :data-source="data"
        :pagination="{
          total: total,
          current: params.page,
          pageSize: params.size,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50', '100', '200'],
          showTotal: (total, range) => `Total ${total} items`,
        }"
        :change="onPageChange"
      >
        <template #bodyCell="{ column, record ,text}">
          <template v-if="column.dataIndex === 'date'">
            {{ formatDate(record.date) }}
          </template>
          <template v-if="column.name === 'showCurrency'">
          {{text ? AMAZON_CURRENCY_MAPPER[props.marketplace] : ''}}{{text}}
        </template>
        </template>
      </artmisads-table>
      </div>
    </div>
  </artmisads-modal>
</template>

<script setup>
import { ref, watch } from 'vue'
import moment from 'moment'
import { associateCentralApi } from '~/server'
import { AMAZON_CURRENCY_MAPPER } from '~/contants/common';
import { useTableScrollHeight } from '@/utils/useTableScrollHeight'
const props = defineProps({
  open: {
    type: Boolean,
    default: false
  },
  batchId: {
    type: String,
    default: ''
  },
  marketplace: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['update:open'])
const { tableScrollHeight } = useTableScrollHeight({
  selector: '.table-wrapper',
  bottomSpace: 155,
  minHeight: 200,
  maxHeight: 800,
  defaultHeight: 350
});
const loading = ref(false)
const data = ref([])
const total = ref(0)
const searchValue = ref('')
const params = ref({
  page: 1,
  size: 10,
  batchId: '',
  keyword: undefined
})

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    align: 'left',
    width: 600,
  },
  {
    title: 'ASIN',
    dataIndex: 'asin',
    align: 'center',
  },
  {
    title: 'Seller',
    dataIndex: 'seller',
    align: 'center',
  
  },
  {
    title: 'Tracking ID',
    dataIndex: 'trackingId',
    align: 'center',
   
  },
  {
    title: 'Date Shipped',
    dataIndex: 'dateShipped',
    align: 'center',
   
  },
  {
    title: 'Price',
    dataIndex: 'price',
    align: 'center',
    name: 'showCurrency',
  },
  {
    title: 'Items Shipped',
    dataIndex: 'itemsShipped',
    align: 'center',
  },
  {
    title: 'Returns',
    dataIndex: 'returns',
    align: 'center',
  },
  {
    title: 'Revenue',
    dataIndex: 'revenue',
    align: 'center',
 
    name: 'showCurrency',
  },
  {
    title: 'Ad Fees',
    dataIndex: 'adFees',
    align: 'center',
   
    name: 'showCurrency',
  },
 
 
 
]

const formatDate = (date) => {
  if(date){ 
    return moment(date).format('YYYY-MM-DD')
  }
  return '--'
}

const getData = () => {
  loading.value = true
  associateCentralApi.getUploadReportsDetail(params.value).then(res => {
    data.value = res.data.data
    total.value = res.data.total
  }).finally(() => {
    loading.value = false
  })
}

const onPageChange = (data) => {
  const { current, pageSize } = data;
  params.value.page = current
  params.value.size = pageSize
  getData()
}

const onSearch = (value) => {
  params.value.keyword = value
  params.value.page = 1
  getData()
}

watch(() => props.batchId, (val) => {
 
})

watch(() => props.open, (val) => {
  if (!val) {
    data.value = []
    total.value = 0
    searchValue.value = ''
    params.value = {
      page: 1,
      size: 10,
      batchId: '',
      search: ''
    }
  
  }else{
    if (props.batchId) {
    params.value.batchId = props.batchId
    getData()
  }
  }
  
})
</script>

<style lang="less" scoped>
.view-report {
  .search-bar {
    margin-bottom: 16px;
    width: 250px;
  }
  .pagination {
    margin-top: 16px;
    text-align: right;
  }
}
</style> 